import { useState } from 'react'
import { formatBytes } from '../format'
import { useActivity } from '../activity'

export default function ActivityPanel() {
  const { items, cancel, clearFinished } = useActivity()
  const [collapsed, setCollapsed] = useState(false)

  if (items.length === 0) return null

  const active = items.filter((item) => item.status === 'queued' || item.status === 'running')
  const loaded = items.reduce((sum, item) => sum + item.loaded, 0)
  const total = items.reduce((sum, item) => sum + item.total, 0)

  return (
    <section className="uploads" aria-label="진행 중인 일">
      <header>
        <button type="button" className="link" onClick={() => setCollapsed((value) => !value)}>
          {collapsed ? '▲' : '▼'} {active.length > 0 ? `${active.length}건 진행 중` : '완료'}
        </button>
        <span className="muted small">
          {formatBytes(loaded)} / {formatBytes(total)}
        </span>
        {active.length === 0 && (
          <button type="button" className="link" onClick={clearFinished}>
            지우기
          </button>
        )}
      </header>

      {!collapsed && (
        <ul>
          {items.map((item) => {
            // 끝을 모르는 일(total 0)은 채워진 막대 대신 도는 표시를 쓴다. 다 됐다고
            // 보이는 막대는 아직 도는 중이라는 말과 정반대다.
            const running = item.status === 'queued' || item.status === 'running'
            const unknownEnd = item.total === 0 && running
            const ratio = item.total === 0 ? 1 : item.loaded / item.total

            return (
              <li key={item.id} className={`upload-item ${item.status}`}>
                <div className="upload-row">
                  <span className="upload-name" title={item.targetPath}>
                    {item.name}
                  </span>
                  {running && item.cancellable ? (
                    <button type="button" className="link" onClick={() => cancel(item.id)}>
                      취소
                    </button>
                  ) : (
                    <span className="muted small">{running ? '' : statusLabel(item.status)}</span>
                  )}
                </div>
                <span className="quota-track">
                  <span
                    className={
                      unknownEnd
                        ? 'quota-fill working'
                        : `quota-fill ${item.status === 'error' ? 'full' : 'ok'}`
                    }
                    style={unknownEnd ? undefined : { width: `${ratio * 100}%` }}
                  />
                </span>
                {item.detail && <p className="muted small">{item.detail}</p>}
                {item.error && <p className="error small">{item.error}</p>}
              </li>
            )
          })}
        </ul>
      )}
    </section>
  )
}

function statusLabel(status: string): string {
  switch (status) {
    case 'done':
      return '완료'
    case 'error':
      return '실패'
    case 'cancelled':
      return '취소됨'
    default:
      return status
  }
}
